import { Container, Heading, Button, Body } from '@hover/blueprint';
import { Link } from 'gatsby';
import React from 'react';
import { TrustedByNamesSlide } from '../../common';

const FitIntoYourMobile: React.FC = () => (
  <Container
    pt="72px"
    pb={1000}
    px={400}
    d={{ base: 'block', tablet: 'none' }}
    maxW="100%"
    centerContent
  >
    <Container px={200} flexDir="column" alingItems="center" maxW="100%">
      <Heading size={{ base: 500, tablet: 600 }} textAlign="center">
        We fit into your business, not the other way around
      </Heading>
      <Heading size={200} isDisplay textAlign="center" marginBottom={800}>
        HOVER integrates with your favorite tools, so you can share measurements
        and estimates and track jobs across a variety of platforms. It
        shouldn&apos;t be hard to make things easier.
      </Heading>
    </Container>
    <TrustedByNamesSlide />
    <Button
      mt={700}
      as={Link}
      size="large"
      to={`${process.env.GATSBY_V2_PREFIX}/partners`}
    >
      <Body letterSpacng="1px" color="neutral.0" size={300} isBold>
        PARTNERS AND INTEGRATIONS
      </Body>
    </Button>
  </Container>
);

export default FitIntoYourMobile;
